function waitForCheckboxes(selector, callback, interval = 100, timeout = 5000) {
  const start = Date.now();

  const check = () => {
    const elements = document.querySelectorAll(selector);
    if (elements.length) {
      callback(elements);
    } else if (Date.now() - start < timeout) {
      setTimeout(check, interval);
    } else {
      console.warn("⚠️ No se encontraron checkboxes después del tiempo de espera.");
    }
  };

  check();
}

waitForCheckboxes('.tpo-checkbox-button', function (checkboxes) {
  const maxFlavors = 3;

  // Usamos el contenedor padre de todos los labels para ubicar el mensaje
  let wrapper = checkboxes[0]?.closest('.container-wrap-selection') || document.body;

  // Crear y agregar mensaje de error si no existe
  let errorBox = document.getElementById('flavor-limit-error');
  if (!errorBox) {
    errorBox = document.createElement('div');
    errorBox.id = 'flavor-limit-error';
    errorBox.style.color = 'red';
    errorBox.style.fontSize = '13px';
    errorBox.style.marginTop = '6px';
    errorBox.style.display = 'none';
    errorBox.textContent = 'You can only select 1,2 or 3 flavors.';
    wrapper.appendChild(errorBox);
  }

  checkboxes.forEach(function (cb) {
    const label = cb.closest('label');

    label.addEventListener('click', function (e) {
      const checked = Array.from(checkboxes).filter(c => c.checked);
      const isTryingToCheck = !cb.checked;

      if (isTryingToCheck && checked.length >= maxFlavors) {
        e.preventDefault();
        e.stopImmediatePropagation();
        errorBox.style.display = 'block';
        return false;
      } else {
        errorBox.style.display = 'none';
      }
    }, true); // ⚠️ usando capture mode
  });
});
